import { __assign } from 'tslib';
import * as React from 'react';

/**
 * @description UserPlus icon component.
 *
 * @component
 * @example
 * ```jsx
 * import { UserPlus } from '@sravni/design-system-icons'
 *
 * <UserPlus />
 * ```
 */
var UserPlus = React.forwardRef(function (props, ref) { return (React.createElement("svg", __assign({ ref: ref, "data-qa": "UserPlus", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M14.215 16.428V15a2.857 2.857 0 0 0-2.857-2.857H5.643A2.857 2.857 0 0 0 2.786 15v1.428M16 10.5v-5M13.5 8h5M8.5 9.286a2.857 2.857 0 1 0 0-5.715 2.857 2.857 0 0 0 0 5.715Z", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }))); });

export { UserPlus };
//# sourceMappingURL=UserPlus.js.map
